/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import { Center, Text } from '@mantine/core';
import {
  MantineReactTable,
  MRT_Cell,
  useMantineReactTable,
  type MRT_ColumnDef,
  type MRT_RowData, // default shape of TData (Record<string, any>)
  type MRT_TableOptions,
} from 'mantine-react-table';
import { MRT_Localization_PT_BR } from 'mantine-react-table/locales/pt-BR';
import { ReactNode } from 'react';

interface Props<TData extends MRT_RowData> extends MRT_TableOptions<TData> {
  columns: MRT_ColumnDef<TData>[];
  data: TData[];
}

export const DefaultValue = 'N/A';

export function DefaultCell<T extends MRT_RowData>({
  cell,
  renderedCellValue,
}: {
  cell: MRT_Cell<T>;
  renderedCellValue: ReactNode;
}) {
  const value = cell.getValue();
  return value && value !== DefaultValue ? (
    <span>{renderedCellValue}</span>
  ) : (
    <Text c="dimmed">{DefaultValue}</Text>
  );
}

export function CustomTable<TData extends MRT_RowData>({ columns, data, ...rest }: Readonly<Props<TData>>) {
  const table = useMantineReactTable({
    columns,
    data,
    mantinePaginationProps: {
      rowsPerPageOptions: ['10', '25', '50', '100'],
    },
    // globalFilterFn: (row: { getValue: (arg0: any) => any }, columnId: any, filterValue: string) => {
    //   const value = row.getValue(columnId);

    //   if (typeof value === 'boolean') {
    //     const label = value ? 'Sim' : 'Não';
    //     return label.toLowerCase().includes(filterValue.toLowerCase());
    //   }

    //   // fallback for text columns
    //   return String(value ?? '')
    //     .toLowerCase()
    //     .includes(filterValue.toLowerCase());
    // },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    renderEmptyRowsFallback(props) {
      return (
        <Center>
          <Text c="dimmed" fs="italic" pt="md" pb="md">
            Não há registros a serem exibidos
          </Text>
        </Center>
      );
    },
    ...rest,
    localization: MRT_Localization_PT_BR,
  });

  return <MantineReactTable table={table} />;
}
